var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"url-page"},[(_vm.type)?_c(_vm.type,{tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }